// DatoCMS derives og:locale from the project locale ("en"), which yields the
// invalid tag "en_EN". Renaming the project locale to "en-NZ" would rewrite the
// locale on every record, so we correct the tag as it is rendered instead.
const SITE_LOCALE = 'en_NZ'

export const withSiteLocale = seoMetaTags => {
  if (!seoMetaTags?.tags) return seoMetaTags

  return {
    ...seoMetaTags,
    tags: seoMetaTags.tags.map(tag =>
      tag?.attributes?.property === 'og:locale'
        ? { ...tag, attributes: { ...tag.attributes, content: SITE_LOCALE } }
        : tag
    )
  }
}
